import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { useCurrentEditor } from '@tiptap/react';
import { Button } from 'antd';

import GalleryIcon from '../../../../../resources/icons/editor/GalleryIcon';
import ParagraphSpacingIcon from '../../../../../resources/icons/editor/ParagraphSpacingIcon';

import { selectDarkMode } from '../../../../../userBrowserSettings/store/browserSettings.selectors';

import KeyPressListener from '../../../keyPressListener/KeyPressListener';
import { keyActionTypes } from '../../../keyPressListener/constants';

import { getIconColorByDarkMode } from '../constants';

import { getThemeColorClass } from '../../../../../utils/helpers/themeHelpers';

import { getCorrectEndPosition } from '../../utils/aiSpellCheckerHelpers';
import ToolbarTooltip from '../ToolbarTooltip';
import SelectImageInput from './content/SelectImageInput';

const classes = {
    galleryButtonsSection: 'gallery-buttons-section',
};

const GalleryButtonsSection = ({ disabled = false }) => {
    const inputFile = useRef();

    const { editor } = useCurrentEditor();

    const darkMode = useSelector(selectDarkMode);

    const handleInsertImage = () => {
        inputFile?.current?.click();
    };

    const themeColorClass = getThemeColorClass(darkMode);

    return (
        <div className={`${classes.galleryButtonsSection} ${themeColorClass}`}>
            <KeyPressListener
                onKeyPress={handleInsertImage}
                keyAction={keyActionTypes.insertImage}
            />
            <ToolbarTooltip disabled={disabled} title='Insert image'>
                <SelectImageInput inputFile={inputFile} />
                <Button
                    disabled={disabled}
                    icon={<GalleryIcon color={getIconColorByDarkMode(darkMode)} />}
                    onClick={() => {
                        inputFile?.current?.click();
                    }}
                />
            </ToolbarTooltip>
            <ToolbarTooltip disabled={disabled} title='Insert Horizontal Line'>
                <Button
                    disabled={disabled}
                    icon={<ParagraphSpacingIcon color={getIconColorByDarkMode(darkMode)} />}
                    onClick={() => {
                        const { to } = editor.state.selection;
                        const insertedContentType = 'horizontalRule';
                        const correctedPos = getCorrectEndPosition(editor, to);

                        editor
                            .chain()
                            .focus()
                            .insertContentAt(correctedPos, { type: insertedContentType })
                            .run();
                    }}
                />
            </ToolbarTooltip>
        </div>
    );
};

export default GalleryButtonsSection;
